<template>
  <div
    v-if="fbPage"
    class="fb-page"
    :data-href="fbPage"
    data-width=""
    data-height="540"
    data-small-header="false"
    data-adapt-container-width="true"
    data-hide-cover="false"
    data-show-facepile="true"
    v-bind="bind"
  >
    <blockquote :cite="fbPage" class="fb-xfbml-parse-ignore">
      <a target="_blank" :href="fbPage">{{ user.name }}</a>
    </blockquote>
  </div>
</template>

<script>
import { computed, onMounted } from '@nuxtjs/composition-api';

export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
    showTimeline: {
      type: Boolean,
      defaults: false,
    },
  },
  setup(props) {
    const fbPage = computed(() => props.user.facebookPage);

    const bind = {};
    if (props.showTimeline) {
      bind['data-tabs'] = 'timeline';
    }

    onMounted(async () => {
      const { initFacebookSdk } = await import('~/modules/common/utils/facebookUtils');
      await initFacebookSdk();
    });
    return { bind, fbPage };
  },
};
</script>
